/*
 * Module for the JobHistory Index View
 */
rs.module("content/jobs/history/index",

    [
        "common/select-helper",
        "controls/data/grid"
    ],

    function (selectHelper, gridModule) {

        // Initialize the page
        function initialize(jsSelectors, backendUrls, lrsGridApi, filterModel, enableRefreshTimer) {

            // standard time interval of 10000ms = 10 seconds
            const normalTimeout = 10000;

            var filter = $.js(jsSelectors.filter);

            var jobSelect = filter.js(jsSelectors.jobSelect);
            var jobScheduleSelect = filter.js(jsSelectors.jobScheduleSelect);

            // holds the timeout for refreshing the grid
            var refreshTimer = enableRefreshTimer ? setupTimer(normalTimeout) : null;

            // setup the timer for delayed recurring grid refresh
            function setupTimer(timeout) {
                return setTimeout(refreshJobHistoryGrid, timeout);
            }

            // refresh the job history grid
            function refreshJobHistoryGrid() {

                // reset the timer
                clearTimeout(refreshTimer);

                gridModule.update(
                    backendUrls.backendJobHistoryUrl,
                    filterModel,
                    lrsGridApi.agGridApi,
                    function done() {
                        if (enableRefreshTimer) {
                            // new refresh timer to run in 10 secs
                            refreshTimer = setupTimer(normalTimeout);
                        }
                    }
                );
            }

            // Get Select Helper for jobScheduleSelect since we're updating its options and properties
            var jobScheduleSelectHelper = selectHelper.getHelper(jobScheduleSelect);

            jobSelect.change(jobSelected);

            // On job selection change, handle population of associated job schedules
            function jobSelected() {

                // load associated job schedules if a specific job was selected
                var allJobs = jobSelect.val() == "";

                if (allJobs) {

                    jobScheduleSelectHelper.clearOptions();

                } else {

                    // get selected job
                    var selectedJobID = jobSelect.val();

                    // populate job schedules based on selected job
                    jobScheduleSelectHelper.loadOptionsFrom(backendUrls.backendJobSchedulesUrl, { jobID: selectedJobID }, { withBlank: true });
                }

                // enable/disable job schedule select based on job selected
                jobScheduleSelectHelper.setDisabled(allJobs);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);